import React, { useEffect, useState } from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { setCompanyVerificationType } from "../../useReducer/actionCreators"
import useOption from "./useOption"
import companyServices from "../../../../../services/copmanyServices"

const ALL_OPTION = { value: "All", id: "" }

const CompanyVerificationTypeDropdown = ({
  externalDispatch,
  selectedType,
}) => {
  const [options, setOptions] = useState([ALL_OPTION])
  const [option, setOption] = useOption(selectedType, options)

  useEffect(() => {
    let isMounted = true

    companyServices
      .getVerificationTypes()
      .then(({ data }) => {
        if (!isMounted) {
          return
        }

        const visibleTypes = (data || []).filter(
          (item) => item.id !== "industry_verified",
        )
        setOptions([ALL_OPTION, ...visibleTypes])
      })
      .catch(() => {
        if (isMounted) {
          setOptions([ALL_OPTION])
        }
      })

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <Dropdown
      label="Verification Status"
      id="company_verification_type_dropdown"
      options={options}
      value={option}
      onChange={(selectedOption) => {
        setOption(selectedOption)
        externalDispatch(setCompanyVerificationType(selectedOption.id))
      }}
    />
  )
}

export default CompanyVerificationTypeDropdown
